<div class="fieldset" [ngClass]="{'disabled' :disabled}">
  <ng-template #content>
    @if (enableSelectAll && options.length > 0) {
      <div class="row g-0 pb-1 mb-2 border-bottom">
        <div class="col-sm-6 col-xl-4">
          <div class="form-check">
            <input [checked]="options.length === selectedValues.length" (click)="toggleSelectAll()"
                   class="form-check-input" type="checkbox" [id]="id + '-' + 'selectAll'">
            <label class="form-check-label" [attr.for]="id + '-' + 'selectAll'">
              Select all
            </label>
          </div>
        </div>
      </div>
    }
    <div class="row g-0">
      @for (option of options; track option; let index = $index) {
        <div class="col-sm-6 col-xl-4">
          <div class="form-check">
            <input [checked]="isSelected(option)" (click)="toggleOption(option)" class="form-check-input"
                   type="checkbox"
                   [id]="id + '-' + index">
            <label class="form-check-label" [attr.for]="id + '-' + index">
              {{ formatter(option) }}
            </label>
          </div>
        </div>
      }
    </div>
  </ng-template>

  @if (hideButton) {
    <div>
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  } @else {
    @if (!horizontal) {
      <button onPopover [popoverContent]="content" popoverClass="multiselect-container"
              [ngClass]="{'btn-invalid': required && selectedValues.length === 0}" popoverTitle="{{title}}"
              [id]="id + '-toggle'" type="button" [placement]="placement" class="btn btn-info col-4">
        Select
      </button>
    }
  }

</div>
@if (!hideSelected) {
  @if (horizontal) {
    <div class="d-flex">
      @if (!hideButton) {
        <div>
          <button onPopover [popoverContent]="content" popoverClass="multiselect-container" [disabled]="disabled"
                  [ngClass]="{'btn-invalid': required && selectedValues.length === 0}" popoverTitle="{{title}}"
                  [id]="id + '-toggle'" type="button" [placement]="placement" class="btn btn-info me-2">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
        </div>
      }
      <div>
        @for (option of selectedValues; track option) {
          <span class="badge text-bg-light text-dark me-1">{{ formatter(option) }}</span>
        }
      </div>
    </div>
  }
  @if (!horizontal) {
    @for (option of selectedValues; track option) {
      <div class="text-muted border p-1 my-2 rounded">{{ formatter(option) }}</div>
    }
    <ng-content select=".invalid-feedback"></ng-content>
  }
}
